import React, { useEffect, useRef } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { useToast } from '../../../hooks/useToast';

const PIPEDRIVE_FORM_URL = 'https://webforms.pipedrive.com/f/6UEdbDg7GgvR0Z36WLmyFgYabd59W6BU3LLIYxW8TQqzZ6cDVTbIvyKNRJzi0uBeLx';
const PIPEDRIVE_LOADER_SRC = 'https://webforms.pipedrive.com/f/loader';

const HelpCenterContactForm = () => {
    const { username, userClientName } = useStoreState(state => state.auth);
    const { setView } = useStoreActions(actions => actions.helpCenter);
    const toast = useToast();
    const formContainerRef = useRef(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = PIPEDRIVE_LOADER_SRC;
        formContainerRef.current?.appendChild(script);
    }, []);

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value ?? '');
        toast.open({ message: 'Copié dans le presse-papier', variant: 'success' });
    };

    return (
        <div className="help-center-contact-form">
            <span className="help-center-back-link" onClick={() => setView('home')}>
                <i className="fas fa-arrow-left" /> Retour à l&apos;aide
            </span>
            <h2 className="help-center-tree-title">Nous contacter</h2>

            <p className="help-center-contact-hint">
                Copiez-collez vos informations ci-dessous dans le formulaire pour nous permettre de vous identifier plus rapidement.
            </p>

            <div className="help-center-contact-copy-fields">
                <div className="help-center-contact-copy-field">
                    <div>
                        <span className="help-center-contact-copy-label">Adresse email</span>
                        <span className="help-center-contact-copy-value">{username}</span>
                    </div>
                    <button
                        type="button"
                        className="help-center-contact-copy-btn"
                        onClick={() => copyToClipboard(username)}
                        aria-label="Copier l'adresse email"
                    >
                        <i className="fas fa-copy" />
                    </button>
                </div>

                <div className="help-center-contact-copy-field">
                    <div>
                        <span className="help-center-contact-copy-label">Nom de votre organisation</span>
                        <span className="help-center-contact-copy-value">{userClientName}</span>
                    </div>
                    <button
                        type="button"
                        className="help-center-contact-copy-btn"
                        onClick={() => copyToClipboard(userClientName)}
                        aria-label="Copier le nom de l'organisation"
                    >
                        <i className="fas fa-copy" />
                    </button>
                </div>
            </div>

            <div ref={formContainerRef} className="pipedriveWebForms" data-pd-webforms={PIPEDRIVE_FORM_URL} />
        </div>
    );
};

export default HelpCenterContactForm;
